import React from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import I18n from 'i18n-js';
import styles from '../styles.less';

const InsuranceFee = ({ delivery, index }) => {
  const fareDetailMatrix = _get(delivery, 'fareDetailMatrix', []);
  const insuranceFeeObj =
    fareDetailMatrix &&
    fareDetailMatrix.find(fare => fare.fieldType === 'INSURANCE_FEE');
  const insuranceFee = insuranceFeeObj ? insuranceFeeObj.value : 0;
  if (!insuranceFeeObj) {
    return null;
  }
  return (
    <div key={delivery.id} className={styles.quote}>
      <span>
        {I18n.t('v2.anytimeBooking.deliveryForm.insuranceConfiguration')}{' '}
        {index + 1}
      </span>
      <span className={styles.priceTag}>
        <span> {insuranceFee}</span>
      </span>
    </div>
  );
};

InsuranceFee.propTypes = {
  delivery: PropTypes.shape({}).isRequired,
  index: PropTypes.number.isRequired,
};

export default InsuranceFee;
